import * as runtime from '../lib/regenerator-runtime-0.13.3/runtime.js';
import Mutil from './index.js';
window.Mutil = Mutil;